import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface GetStartedButtonProps {
	variant?: 'mobile' | 'desktop';
	text?: string;
	URL?: string;
	onClick?: () => void;
}

export function GetStartedButton({
	URL = '/contact-us',
	text = 'Get Started',
	variant = 'desktop',
	onClick,
}: GetStartedButtonProps) {
	return (
		<Link href={URL} passHref>
			<Button
				asChild
				variant="outline"
				className={cn(
					'transition-colors duration-200',
					variant === 'mobile'
						? 'w-full'
						: 'hidden hover:bg-blue-50 md:inline-flex',
				)}
				onClick={onClick}>
				<p className="text-gray-700">{text}</p>
			</Button>
		</Link>
	);
}
